(() => {
  const ROOT_SELECTOR = '[data-ts-brand-hub]';
  const ALL_VALUE = 'すべて';
  const CHIP_GROUPS = [
    { key: 'country', label: '国' },
    { key: 'taste', label: 'テイスト' },
    { key: 'use', label: '用途' },
  ];

  const normalizeText = (value) =>
    (value || '')
      .toString()
      .normalize('NFKC')
      .replace(/\s+/g, ' ')
      .trim();

  const normalizeSearch = (value) =>
    normalizeText(value)
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' ')
      .replace(/[^0-9a-z\u3040-\u30ff\u3400-\u9fff]+/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const buildChipButton = (groupKey, label, activeValue) => `
    <button
      type="button"
      class="ts-brand-hub__chip${activeValue === label ? ' is-active' : ''}"
      data-brand-hub-chip
      data-chip-group="${groupKey}"
      data-chip-value="${label}"
      aria-pressed="${activeValue === label ? 'true' : 'false'}"
    >
      ${label}
    </button>
  `;

  const initBrandHub = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const cards = Array.from(root.querySelectorAll('[data-brand-card]'));
    const searchInput = root.querySelector('[data-brand-hub-search]');
    const status = root.querySelector('[data-brand-hub-status]');
    const chipHost = root.querySelector('[data-brand-hub-chip-groups]');
    const emptyState = root.querySelector('[data-brand-hub-empty]');

    const state = {
      search: '',
      country: '',
      taste: '',
      use: '',
    };

    const buildChipGroups = () => {
      if (!chipHost) return;
      chipHost.innerHTML = CHIP_GROUPS.map((group) => {
        const values = Array.from(
          new Set(
            cards
              .map((card) => normalizeText(card.dataset[group.key]))
              .filter(Boolean)
          )
        ).sort((left, right) => left.localeCompare(right, 'ja'));

        if (!values.length) return '';

        return `
          <section class="ts-brand-hub__chip-group">
            <p class="ts-brand-hub__chip-label">${group.label}</p>
            <div class="ts-brand-hub__chip-row">
              ${buildChipButton(group.key, 'すべて', state[group.key])}
              ${values.map((value) => buildChipButton(group.key, value, state[group.key])).join('')}
            </div>
          </section>
        `;
      }).join('');
    };

    const update = () => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const searchText = normalizeSearch(card.dataset.searchText);
        const searchMatch = !state.search || searchText.includes(state.search);
        const countryMatch = !state.country || normalizeText(card.dataset.country) === state.country;
        const tasteMatch = !state.taste || normalizeText(card.dataset.taste) === state.taste;
        const useMatch = !state.use || normalizeText(card.dataset.use) === state.use;
        const isVisible = searchMatch && countryMatch && tasteMatch && useMatch;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (status) {
        status.textContent = `${visibleCount}ブランドを表示中です。`;
      }
      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      }
      buildChipGroups();
    };

    searchInput?.addEventListener('input', (event) => {
      state.search = normalizeSearch(event.target.value);
      update();
    });

    root.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-brand-hub-chip]');
      if (!chip) return;
      const group = chip.dataset.chipGroup;
      const value = normalizeText(chip.dataset.chipValue);
      state[group] = value === ALL_VALUE ? '' : value;
      update();
    });

    update();
  };

  const boot = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initBrandHub);
  };

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
